import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Button from "../../../../Core/Button/Button.jsx";
import Table1 from "./Table1";
const Tab1 = ({
  pageState,
  handleChange,
  onInputChange,
  invoiceList,
  userList,
  CompanyList,
  errors,
  setselected_item_data,

  CostCenterList,
  list_data,
}) => {
  const statusList = [
    { name: "Passive" },
    { name: "Open" },
    { name: "Replied" },
  ];
  const getToday = () => {
    return new Date().toISOString().split("T")[0];
  };

  return (
    <div>
      <div className="px-3 pb-2 pt-4" style={{ background: "white" }}>
        <div className="mb-3" style={{ display: "flex", gap: "20px" }}>
          <div className="col-md-12" style={{ display: "flex" }}>
            <div className="col-md-6 px-2">
              <div
                className=""
                style={{
                  backgroundColor: "#EBE6FA",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                }}
              >
                <div className="">
                  <h5 className="fw-semibold ">Type of Payment</h5>
                </div>

                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="date"
                      label="Series"
                      style={{
                        height: "30px",
                      }}
                      value={getToday()}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label htmlFor="" style={{ fontSize: "0.8rem" }}>
                      Posting Date
                    </label>
                    <input
                      type="date"
                      className="form-control tableinput noborder"
                      style={{ fontSize: "0.8rem" }}
                      value={getToday()}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Payment Type"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("PaymentType", val)}
                      placeholder=""
                    />
                  </div>
                </div>
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="From Template"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) =>
                        handleChange("ClosingAccountHead", val)
                      }
                      placeholder=""
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Company"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("Company", val)}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 px-2">
              <div
                style={{
                  backgroundColor: "#E3F5DF",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                  gap: "15px",
                }}
              >
                {/* Row 1 */}
                <div className="">
                  <h5 className="fw-semibold m-0">Payment From / To</h5>
                </div>

                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Party Type"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("PartyType", val)}
                      placeholder=""
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Party"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("Party", val)}
                      placeholder=""
                    />
                  </div>
                </div>

                {/* Row 2 */}
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Company Bank Account"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) =>
                        handleChange("CompanyBankAccount", val)
                      }
                      placeholder=""
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Party Bank Account"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("PartyBankAccount", val)}
                      placeholder=""
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Contact"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("Contact", val)}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-3 pb-4" style={{ background: "white" }}>
        <div className="" style={{ display: "flex", gap: "20px" }}>
          <div className="col-md-12" style={{ display: "flex" }}>
            <div className="col-md-6 px-2">
              <div
                style={{
                  backgroundColor: "#FEFAF4",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                  gap: "15px",
                }}
              >
                {/* Row 1 */}
                <div className="">
                  <h5 className="fw-semibold m-0">Accounts</h5>
                </div>

                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Account Paid To"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("AccountPaidTo", val)}
                      placeholder=""
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <Input
                        id="from_currency"
                      label=" Party Balance"
                      style={{
                        height: "30px",
                      }}
                    />
                  </div>
                </div>

                {/* Row 2 */}
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Account Paid From"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) =>
                        handleChange("AccountPaidFrom", val)
                      }
                      placeholder=""
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                     <Input
                      id=""
                      label="Account Currency (From)"
                      style={{
                        height: "30px",
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                     <Input
                      id=""
                      label="Account Balance (From)"
                      style={{
                        height: "30px",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>{" "}
            <div className="col-md-6 px-2">
              <div
                style={{
                  backgroundColor: "#F6F7FC",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                  gap: "15px",
                }}
              >
                {/* Row 1 */}
                <div className="">
                  <h5 className="fw-semibold m-0">Taxes & GST Details</h5>
                </div>

                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Sales Taxes and Charges Template"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("SalesTaxesandChargesTemplate", val)}
                      placeholder=""
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                     <Input
                      id=""
                      label="GST Category)"
                      style={{
                        height: "30px",
                      }}
                    />
                  </div>
                     <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Company Bank Account"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) =>
                        handleChange("CompanyBankAccount", val)
                      }
                      placeholder=""
                    />
                  </div>
                </div>

                {/* Row 2 */}
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Company Address"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) =>
                        handleChange("CompanyAddress", val)
                      }
                      placeholder=""
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Customer Address"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("CustomerAddress", val)}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-3">
        <div
          className="col-md-12 px-2"
          style={{ display: "flex", gap: "20px" }}
        >
          <div
            className=""
            style={{
              height: "100%",
              borderRadius: "4px",
              display: "flex",
              flexDirection: "column",
              width: "100%",
              padding: "10px",
              border: "1px solid #DBDBDB",
              borderRadius: "5px",
            }}
          >
            <div style={{ display: "flex", gap: "15px" }}>
              <div style={{ flex: 1 }}>
                <p className="" style={{ fontSize: "16px", fontWeight: "600" }}>
                  Cost Center Allocation Percentages
                </p>
              </div>
            </div>
            <Table1 setselected_item_data={setselected_item_data} />
          </div>
        </div>
      </div>
       <div className="px-3 pb-4" style={{ background: "white" }}>
        <div className="" style={{ display: "flex", gap: "20px" }}>
          <div className="col-md-12" style={{ display: "flex" }}>
            <div className="col-md-6 px-2">
              <div
                style={{
                  backgroundColor: "#FFF7F6",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                  gap: "15px",
                }}
              >
                {/* Row 1 */}
                <div className="">
                  <h5 className="fw-semibold m-0">Accounting Dimensions</h5>
                </div>

                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Account Paid To"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("AccountPaidTo", val)}
                      placeholder=""
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                   <SelectSearch
                      list={CompanyList}
                      label="Cost Center"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("CostCenter", val)}
                      placeholder=""
                    />
                  </div>
                </div>

                {/* Row 2 */}
             
              </div>
            </div>{" "}
     
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tab1;
